<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="active"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >

        <el-tabs v-model="active" @tab-click="onStatusChange">
          <el-tab-pane label="已发布，报名中" name="0"></el-tab-pane>
          <el-tab-pane label="已完成，待结算" name="1"></el-tab-pane>
          <el-tab-pane label="已完成" name="2"></el-tab-pane>
        </el-tabs>

        <el-table ref="table" :data="list" row-key="id" :show-header="false">
          <el-table-column label="报名会议" fixed="left" prop="title">
            <template scope="scope">
              <div class="goods-name" v-if="scope.row.member_list.length>0">
                      <span v-for="(member,mkey)  in order.member_list" v-if="mkey<4"
                            :key="mkey">{{ member.name }} </span>
                等{{ scope.row.members }}人报名
              </div>
              <div class="goods-name" v-else>
                暂无人员报名
              </div>
              <div class="gray-light">
                {{scope.row.danwei}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="人数" prop="renshu">
            <template scope="scope">
              <div class="goods-price" v-show="scope.row.order_price>0"><span>¥</span>{{ scope.row.order_price }}</div>
              <div class="goods-num gray-light">人数 {{ scope.row.members }}</div>
              <el-tag
                  v-if="scope.row.status == 2"
                  type="success"
              >
                已支付
              </el-tag>
              <div v-if="scope.row.status == 2">请去PC管理后台，编排出场顺序</div>
            </template>
          </el-table-column>
          <el-table-column label="日期" prop="riqi">
            <template scope="scope">
              {{ scope.row.create_time_str }}
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="action">
            <template scope="scope">
              <el-button size="medium" @click="goDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-pagination">
          <el-pagination
              background
              @current-change="handleCurrentChange" :current-page="parseInt(row.currentpage)"
              :page-size="params.pageSize" layout="total, prev, pager, next"
              :total="row.total">
          </el-pagination>
        </div>

        <el-row>
          <el-col class="footer-button">
            <el-button
                @click="onKaojiSelect({'name' : '发布赛场考级'})"
            >发布赛场考级
            </el-button>
            <el-button
                type="primary"
                @click="onKaojiSelect({'name' : '发布常规考级'})"
            >发布常规考级
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>

      </el-form>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    <van-action-sheet v-model="kaojiShow" :actions="actions" @select="onKaojiSelect"/>
  </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.van-pull-refresh {
  margin-top: 0.3rem
}

.title-left span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.normal-btn {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.count_edit {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}


.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 5px;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  font-size: 14px;
}

.goods-price {
  font-size: 16px;
  margin: 0.1rem 0 0.6rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.pay_order {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}

</style>

<script>
import Vue from 'vue';

import {
  Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button, DropdownMenu, DropdownItem,
  Tab,
  Tabs,
  ActionSheet,
} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem).use(ActionSheet);
export default {
  name: 'ExameApplyListMine',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    LoginDialog
  },
  data: function () {
    return {
      loginShow: false,
      kaojiShow: false,
      active: 0,
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        pageNo: 1,
        pageSize: 5,
        status: 1
      },
      row: {
        total: 0,
      },
      homeTop: 0,
      list: [],
      userType: 2,
      actions: [{name: '发布常规考级'}, {name: '发布赛场考级'}],
    }
  },
  mounted() {
    document.title = "我的考级"

    let that = this;
    // console.log(this.$route.meta)
    if (!this.$route.meta.isBack) {
      // 清空查询条件和数据
      that.list = [];
      that.active = 0;
      that.params.pageNo = 1;
      that.params.status = 1;
      that.params.id = this.$route.query.id;
      that.loading = true;
      that.finished = false;
      that.getList()

      if (this.$route.query.status) {
        that.active = that.params.status = this.$route.query.status;
        console.log(that.active)
      }
    }
    document.getElementById('app').scrollTop = this.homeTop || 0
    this.$route.meta.isBack = false;

  },
  destroyed() {
  },
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val
      this.list = []
      this.getList()
    },
    getList() {
      let that = this;
      that.$api.get('/api/qcxj/applyListQcxj', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
        that.row = res.data
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    onKaojiSelect(item) {
      // v-rblink="{name:'ExameApplyFormBasic'}"
      if (item.name == '发布常规考级') {
        rbLink({name: 'ExameApplyFormBasicMine', query: {id: this.params.id}})
      } else {
        // 暂时不开放
        this.kaojiShow = false
        this.$message.info('暂未开放……')
        return
        rbLink({name: 'ExameApplyFormMatch'})
      }
      this.kaojiShow = false;
    },


    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }

    },

    // 跳转订单详情
    goDetail(order) {
      // 判断是否成团
      console.log(order)
      rbLink({
        'name': 'ExameApplyDetailMine',
        'query': {
          id: order.id
        }
      })

    },


    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },


    // 更改状态
    onStatusChange(tab) {
      let that = this;
      let index = parseInt(tab.name)

      that.params.status = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      that.getList()
    },


    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// ExameApplyListMine.vue?2622a0d9